module.exports = __webpack_public_path__ + "static/media/bulk12.63e82ea2.png";